import clsx from 'clsx';
import React from 'react';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { GetClasses } from '@lifeomic/chroma-react/typeUtils';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
  header: {
    minHeight: theme.pxToRem(51),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  content: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'auto',
  },
}));

export type ContentContainerClasses = GetClasses<typeof useStyles>;

export interface ContentContainerProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  contentClass?: string;
  headerOverrides?: string;
  header?: React.ReactNode;
}

export const ContentContainer: React.FC<ContentContainerProps> = props => {
  const {
    children,
    className,
    contentClass,
    headerOverrides,
    header,
    ...rootProps
  } = props;

  const classes = useStyles(props);

  return (
    <div className={clsx(classes.root, className)} {...rootProps}>
      {!!header && (
        <div className={clsx(classes.header, headerOverrides)}>{header}</div>
      )}
      <div className={clsx(classes.content, contentClass)}>{children}</div>
    </div>
  );
};

export default ContentContainer;
